import "core-js/stable";
import "regenerator-runtime/runtime";
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { createStore, applyMiddleware, compose, getStore } from 'redux';
import reduxThunk from 'redux-thunk';
import * as serviceWorker from './serviceWorker';
import App from './App';
import PickForm from './components/PickForm';
import LetterOfAppeal from './components/LetterOfAppeal';
import LetterOfMedicalNecessity from './components/LetterOfMedicalNecessity';
import FormularyLookup from './components/FormularyLookup';
import InsuranceCoverageLookup from './components/InsuranceCoverageLookup';
import ShortEnrollment from './components/ShortEnrollment';
import ShortEnrollmentButtons from './components/ShortEnrollmentButtons';
import PAMLookup from './components/PAMLookup';
import ScrollToAnchor from './components/hooks/ScrollToAnchor';
import SignupForm from './components/SignupForm';

// Reducers
import reducers from './reducers';

// Styling
import "./App.css";
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";
import { extend } from "lodash";

// Only run devtools in dev
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const enhancer = composeEnhancers(
  applyMiddleware(reduxThunk)
);

// Redux
const store = createStore(
  reducers,
  enhancer
);

console.log("process.env.NODE_ENV", process.env.NODE_ENV);

if (process.env.NODE_ENV !== 'development') {

    if (document.getElementById('scroll-to-anchor-blue')) {
      ReactDOM.render(
        <React.StrictMode>
        <Provider store={store}>
          <ScrollToAnchor type={'blue'}/>
        </Provider>
      </React.StrictMode>,
        document.getElementById('scroll-to-anchor-blue')
      )
    }

    if (document.getElementById('scroll-to-anchor-white')) {
      ReactDOM.render(
        <React.StrictMode>
        <Provider store={store}>
        <ScrollToAnchor type={'white'}/>
        </Provider>
      </React.StrictMode>,
        document.getElementById('scroll-to-anchor-white')
      )
    }
    
    if (document.getElementById('treatment-ltc-form')) {
    ReactDOM.render(
      <React.StrictMode>
        <Provider store={store}>
          <PickForm />
        </Provider>
      </React.StrictMode>,
      document.getElementById('treatment-ltc-form')
    );
  }

  if (document.getElementById('letter-of-appeal-form')) {
    ReactDOM.render(
      <React.StrictMode>
        <Provider store={store}>
          <LetterOfAppeal />
        </Provider>
      </React.StrictMode>,
      document.getElementById('letter-of-appeal-form')
    );
  }

  if (document.getElementById('letter-of-medical-necessity-form')) {
    ReactDOM.render(
      <React.StrictMode>
        <Provider store={store}>
          <LetterOfMedicalNecessity />
        </Provider>
      </React.StrictMode>,
      document.getElementById('letter-of-medical-necessity-form')
    );
  }

  if (document.getElementById('formulary-lookup-form')) {
    ReactDOM.render(
      <React.StrictMode>
        <Provider store={store}>
          <FormularyLookup />
        </Provider>
      </React.StrictMode>,
      document.getElementById('formulary-lookup-form')
    );
  }

  if (document.getElementById('insurance-lookup-form')) {
    ReactDOM.render(
      <React.StrictMode>
        <Provider store={store}>
          <InsuranceCoverageLookup />
        </Provider>
      </React.StrictMode>,
      document.getElementById('insurance-lookup-form')
    );
  }

  if (document.getElementById('enrollment-short')) {
    ReactDOM.render(
      <React.StrictMode>
        <Provider store={store}>
          <ShortEnrollment />
        </Provider>
      </React.StrictMode>,
      document.getElementById('enrollment-short')
    );
  }

  if (document.getElementById('enrollment-short-buttons')) {
    ReactDOM.render(
      <React.StrictMode>
        <Provider store={store}>
          <ShortEnrollmentButtons />
        </Provider>
      </React.StrictMode>,
      document.getElementById('enrollment-short-buttons')
    );
  }

  if (document.getElementById('patient-access-manager-lookup-form')) {
    ReactDOM.render(
      <React.StrictMode>
        <Provider store={store}>
          <PAMLookup isResourcePage={false}/>
        </Provider>
      </React.StrictMode>,
      document.getElementById('patient-access-manager-lookup-form')
    );
  }

  if (document.getElementById('patient-access-manager-lookup-form')) {
    ReactDOM.render(
      <React.StrictMode>
        <Provider store={store}>
          <PAMLookup isResourcePage={false}/>
        </Provider>
      </React.StrictMode>,
      document.getElementById('patient-access-manager-lookup-form')
    );
  }

  if (document.getElementById('sign-up-pdp-form')) {
    ReactDOM.render(
      <React.StrictMode>
        <Provider store= {store}>
          <SignupForm />
        </Provider>
      </React.StrictMode>,
      document.getElementById('sign-up-pdp-form')
    );
  }
  
} else {
  // Dev mode allows us to work on all pages easily with react router
  ReactDOM.render(
    <React.StrictMode>
      <Provider store={store}>
        <App />
      </Provider>
    </React.StrictMode>,
    document.getElementById('root')
  );
}

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
